function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var Ienvelope = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M29 4H3C1.34312 4 0 5.34312 0 7V25C0 26.6569 1.34312 28 3 28H29C30.6569 28 32 26.6569 32 25V7C32 5.34312 30.6569 4 29 4ZM29 7V9.55031C27.5986 10.6915 25.3645 12.466 20.5883 16.2059C19.5357 17.0339 17.4507 19.0229 16 18.9998C14.5495 19.0232 12.4638 17.0336 11.4117 16.2059C6.63625 12.4666 4.40156 10.6917 3 9.55031V7H29ZM3 25V13.3999C4.43212 14.5406 6.46306 16.1413 9.55863 18.5653C10.9247 19.6406 13.317 22.0144 16 21.9999C18.6698 22.0144 21.0318 19.675 22.4408 18.5658C25.5363 16.1418 27.5678 14.5407 29 13.3999V25H3Z",
    fill: "black"
  }));
});